export default __webpack_public_path__ + "static/media/11.f0c18a32.jpg";